import { gENAppsString } from "../Localization/QENStrings";
import { gESAppsString } from "../Localization/QESStrings";
import { gDEAppsString } from "../Localization/QDEStrings";
import { gFRAppsString } from "../Localization/QFRStrings";
import { gZOAppsString } from "../Localization/QZOStrings";
import { gENConnectorStrs } from "../Localization/QENConnStrings";
import { gENHoverTips } from "../Localization/QENHoverStrings";
import { gESConnectorStrs } from "../Localization/QESConnStrings";
import { gESHoverTips } from "../Localization/QESHoverStrings";
import { gDEConnectorStrs } from "../Localization/QDEConnStrings";
import { gDEHoverTips } from "../Localization/QDEHoverStrings";
import { gFRConnectorStrs } from "../Localization/QFRConnStrings";
import { gFRHoverTips } from "../Localization/QFRHoverStrings";
import {
  gENDateFormat,
  gESDateFormat,
  gDEDateFormat,
  gFRDateFormat
} from "../Localization/QDateStrings";
import { enumLanguage, enumIconIndex } from "../constants";
import { gSupportMsgKey, gSalesMsgKey } from "../whitelabel/brand";
import { GetUnknownErrorMessage } from "../utils/GetUnknownErrorMessage";

export class QStringMgr {
  constructor() {
    this.fLookup = null;
    this.fConnLookup = null;
    this.fHoverLookup = null;
    this.fCurLanguage = enumLanguage.english;
    this.fCurLangStr = "en";
    this.fDateFormatLookup = 0;
    this.fFontFaceLookup = "";
  }

  ParseLangCode(langStr) {
    var curLang = langStr.toLowerCase();
    if (curLang.indexOf("_") > 0) curLang = curLang.split("_")[0];
    else curLang = curLang.split("-")[0];
    return curLang;
  }

  ResetStringMgr() {
    var browserLang = navigator.language;
    var appStrs, connStrs, appHover, dateFormat;
    var curLang = localStorage.language;
    if (curLang == null) {
      curLang = browserLang;
    }

    /*
      if (curLang == null || !globalLanguageCodes[curLang] && gUIConfig) {
      curLang = gUIConfig.fDefaultLanguage;
      localStorage.language = curLang;
    }
     */

    curLang = this.ParseLangCode(curLang);
    this.fCurLangStr = curLang;
    switch (curLang) {
      case "de":
        appStrs = gDEAppsString;
        appHover = gDEHoverTips;
        connStrs = gDEConnectorStrs;
        dateFormat = gDEDateFormat;
        this.fCurLanguage = enumLanguage.german;
        break;
      case "fr":
        appStrs = gFRAppsString;
        appHover = gFRHoverTips;
        connStrs = gFRConnectorStrs;
        dateFormat = gFRDateFormat;
        this.fCurLanguage = enumLanguage.french;
        break;
      case "es":
        appStrs = gESAppsString;
        appHover = gESHoverTips;
        connStrs = gESConnectorStrs;
        dateFormat = gESDateFormat;
        this.fCurLanguage = enumLanguage.spanish;
        break;
      case "zo":
        //"en"
        appStrs = gZOAppsString;
        appHover = gENHoverTips;
        connStrs = gENConnectorStrs;
        dateFormat = gENDateFormat;
        this.fCurLanguage = 4;
        break;
      default:
        //"en"
        appStrs = gENAppsString;
        appHover = gENHoverTips;
        connStrs = gENConnectorStrs;
        dateFormat = gENDateFormat;
        this.fCurLanguage = enumLanguage.english;
    }

    this.SetLookupTable(appStrs, connStrs, appHover, dateFormat);
  }

  SetLookupTable(appStrs, connStrs, hoverStr, dateFormat) {
    this.fLookup = appStrs;
    this.fHoverLookup = hoverStr;
    this.fConnLookup = connStrs;
    this.fDateFormatLookup = dateFormat;
  }

  supportmsg() {
    return GetUnknownErrorMessage(gSupportMsgKey, ".", key => this.appstr(key));
  }

  salesmsg() {
    return GetUnknownErrorMessage(gSalesMsgKey, ".", key => this.appstr(key));
  }

  InsertReplacementValues(template, replaceDict) {
    return template.replace(/\{([^\}]+)\}/g, (_, key) => replaceDict[key] || `{${key}}`);
  }

  // TODO: Missing String rework
  appstr(stringCode, replaceDict = {}) {
    var s = this.fLookup[stringCode];
    if (s == null) {
      s = gENAppsString[stringCode];
      console.log("MISSING STR - " + this.fCurLangStr + " - " + stringCode);
    }
    if (s == null) {
      s = "String not found!";
      console.log("MISSING STR - ENGLISH NOT FOUND - " + stringCode);
    }
    if (s != null && Object.keys(replaceDict).length > 0) {
      s = this.InsertReplacementValues(s, replaceDict);
    }

    return s;
  }

  appcstr(stringCode, replaceDict = {}) {
    var s = this.fConnLookup[stringCode];

    if (s == null) s = "String not found!";
    if (s != null && Object.keys(replaceDict).length > 0) {
      s = this.InsertReplacementValues(s, replaceDict);
    }
    return s;
  }

  getHoverTip(hoverCode) {
    if (this.fHoverLookup == null) return "";

    if (this.fHoverLookup[hoverCode]) return this.fHoverLookup[hoverCode];

    return hoverCode;
  }

  GetCurrentLanguage() {
    return this.fCurLanguage;
  }

  GetBoldIcon() {
    switch (this.fCurLanguage) {
      case enumLanguage.french:
        return enumIconIndex.frbold;
    }

    return enumIconIndex.bold;
  }

  GetDateFormatStr(index) {
    return this.fDateFormatLookup[index];
  }

  GetDateFormatStrList() {
    return this.fDateFormatLookup;
  }

  GetFontFaceStr(index) {
    return this.fFontFaceLookup[index];
  }

  GetFontFaceStrList() {
    return this.fFontFaceLookup;
  }
}
